//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  computed: {
    event() {
      return this.$store.state.event.data;
    },
    list() {
      return this.event.additionalArray;
    },
  },
};
